<div class="d-flex flex-column justify-content-between" style="max-height: 100vh; min-height: 100vh;height:100%;max-width: 100vw; min-width: 100vw;width:100%">
  <div>
    <avs-navbar [user]="userData"></avs-navbar>
  </div>
  <div class="d-flex flex-fill overflow-auto h-100 w-100 ">
    <router-outlet></router-outlet>
  </div>
  <div class="avs-footer">
    <avs-app-footer></avs-app-footer>
  </div>
</div>
